import { z } from 'zod';

export const TextPropsSchema = z.object({
  text: z.string(),
  family: z.enum(['default', 'mono']).optional(),
  size: z.number().min(0).max(8).optional(),
  weight: z.enum(['feather', 'base', 'heavy', 'black']).optional(),
  color: z.string().optional(),
});
